import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/* Router Modules */
// import house from './modules/house' 和houseManage.js 可能存在重复/冲突
import service from './modules/service'
import rent from './modules/rent'
import table from './modules/table'
import report from './modules/report'
import amortize from './modules/amortize'
import dash from './modules/dash'
import houseManage from './modules/houseManage'
import mangerPerformance from './modules/mangerPerformance'
import privilegeManagement from './modules/privilegeManagement'
import pay from './modules/pay'
/** 路由过滤器 针对不需要拦截的地址 放行 */
import filter from './filter'

/* comp lazyload */
import _import from './_import'

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: _import('login/index'),
    },

    // 登录
    {
      path: '/login',
      name: 'login',
      component: _import('login/index'),
    },
    {
      path: '/resetLogin',
      name: 'resetLogin',
      component: _import('resetLogin'),
    },
    {
      path: '/register',
      name: 'register',
      component: _import('register'),
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/dash/tasks',
    },
    dash,
    {
      path: '/search',
      name: 'search',
      component: _import('search'),
    },
    {
      path: '/workOrderTool',
      name: 'workOrderTool',
      component: _import('workOrderTool/index'),
    },
    pay,
    // house,
    service,
    rent,
    table,
    amortize,
    report,
    houseManage,
    mangerPerformance,
    privilegeManagement,
  ],
})

router.beforeEach((to, from, next) => {
  let isLoginPage = new RegExp('/login').test(to.fullPath)
  // 不需要拦截的页面
  if (filter(to.fullPath)) {
    next()
  } else {
    // 判断是否存在 currentUserToken
    if (localStorage.getItem('currentUserToken')) {
      if (to.fullPath === '/' || isLoginPage) {
        router.push({ path: '/dash/tasks' })
      } else {
        next()
      }
    } else {
      if (!isLoginPage) {
        router.push({ path: '/login' })
      } else {
        next()
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/route.js